import { types } from "../Actions/types";

const initialState = {
  userslist: [],
  userSingle: null,
};

const Users = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.USERS_LIST:
      return {
        ...state,
        userslist: payload,
      };
    case types.USER_DETAIL:
      return {
        ...state,
        userSingle: payload,
      };

    default:
      return state;
  }
};

export default Users;
